export const formatCurrency = (value) => {
  const safeNumber = Number(value || 0);
  return new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: 0,
  }).format(safeNumber);
};

export const dateKey = (rawDate) => {
  if (!rawDate) {
    return "";
  }

  const date = new Date(rawDate);
  return Number.isNaN(date.getTime()) ? "" : date.toISOString().slice(0, 10);
};

export const toDisplayDate = (rawDate) => {
  if (!rawDate) {
    return "-";
  }

  const date = new Date(rawDate);
  if (Number.isNaN(date.getTime())) {
    return "-";
  }

  return date.toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

export const normalizeName = (value, fallback) => {
  if (!value || typeof value !== "string") {
    return fallback;
  }

  const trimmed = value.trim();
  return trimmed.length > 0 ? trimmed : fallback;
};

export const numberValue = (value) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : 0;
};

export const asArrayTop = (mapObj, topN = 6) => {
  return Object.entries(mapObj)
    .map(([name, count]) => ({ name, count }))
    .sort((a, b) => b.count - a.count)
    .slice(0, topN);
};

export const getVisitCustomerKey = (visit) => {
  return (
    visit.CustomerId ||
    visit.MemberDependentId ||
    visit.MemberId ||
    visit.MobileNumber ||
    ""
  );
};
